import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { IdentityProvider } from "@planzone/dto";

import { TextInput } from "@common/textInput";
import { Checkbox } from "@common/checkbox";
import { Props } from "./types";
import { ProtocolSelect } from "./protocolSelect";
import styles from "./styles.scss";

function CasForm({ identityProvider, edit }: Props) {
  const { t } = useTranslation();
  const e = (nextConf: IdentityProvider["config"]) =>
    edit({
      ...identityProvider,
      config: { ...identityProvider.config, ...nextConf },
    });

  return (
    <div className={styles.casForm}>
      <div className={styles.group}>
        <p className={styles.label}>
          {t("addIdentityProvider.cas.loginUrl.label")}:
        </p>
        <div className={styles.form}>
          <TextInput
            value={identityProvider.config["login-url"] || ""}
            placeholder={t("addIdentityProvider.cas.loginUrl.placeholder")}
            input={(value) => e({ "login-url": value })}
          />
        </div>
      </div>
      <div className={styles.group}>
        <p className={styles.label}>Protocol:</p>
        <div className={styles.form}>
          <ProtocolSelect
            protocol={identityProvider.config["protocol"]}
            select={(protocol) => e({ protocol })}
          />
        </div>
      </div>
      <div className={styles.group}>
        <p className={styles.label}>
          {t("addIdentityProvider.cas.clientName.label")}:
        </p>
        <div className={styles.form}>
          <TextInput
            value={identityProvider.config["client-name"] || ""}
            placeholder={t("addIdentityProvider.cas.clientName.placeholder")}
            input={(value) => e({ "client-name": value })}
          />
        </div>
      </div>
      <div className={styles.checkboxGroup}>
        <p className={styles.label}>{t("addIdentityProvider.cas.enabled")}:</p>
        <div
          className={classNames(styles.form, styles.checkbox)}
          onClick={() =>
            edit({
              ...identityProvider,
              isEnabled: !identityProvider.isEnabled,
            })
          }
        >
          <Checkbox isChecked={identityProvider.isEnabled} />
        </div>
      </div>
    </div>
  );
}

export { CasForm };
